// removed by extract-text-webpack-plugin
module.exports = {"primaryColorBase":"#55C81E","primaryColorLight":"#61d728","primaryColorLighter":"#93da72","primaryColorLightest":"#c3e8b1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/ReCarousel/CarouselAssets/CarouselAssets.scss
// module id = 36
// module chunks = 0